import { Controller } from "@hotwired/stimulus"
import { baseKit, xDataKit } from "../shared/browserKit"
import { generateUUID } from "../shared/functions"
import Alpine from "alpinejs"

// Connects to data-controller="alpine-tree""
export default baseKit((baseKits)=>{
   return class extends Controller {

    static targets = [
      "setup",
    ]
    
    connect() {
      const rootElement = this.element
      const targetScript = this.setupTarget
      const setupUUID = generateUUID("tree_alpine_xxxx_xxxx_yxxx")
      const configUUID = generateUUID("tree_alpine_setup_xxxx_xxxx_yxxx")
      let setupExecuted = false
      function setupAlpineData(appConfig){
        if(setupExecuted){
          throw new Error("alpine-tree의 셋업 스크립트는 한 번만 호출되어야 합니다.")
        } else {
          setupExecuted = true
        }
        if(typeof rootElement.getAttribute("x-ignore") !== "string"){
          throw new Error("data-controller=alpine-tree는 반드시 x-ignore 속성을 가지고 있어야 합니다.")
        }
        window[configUUID] = appConfig
        rootElement._x_ignore = false
        rootElement.removeAttribute("x-ignore")
        rootElement.setAttribute("x-data", `window["${configUUID}"]`)
        Alpine.initTree(rootElement)
      }
      if(targetScript){
        function jumpStarter (setupCallback){
          const result = setupAlpineData(xDataKit((kits)=>setupCallback({ ...kits })))
          if(result){
            delete window[setupUUID]
          }
          return result
        }
        if(targetScript.dataset.connectPeerId){
          // stimulus가 script보다 먼저 준비된 경우 - 페이지 열기, Turbo.visit
          window[targetScript.dataset.connectPeerId](jumpStarter)
        } else {
          // script가 stimulus보다 먼저 실행된 경우 - turbo-frame 로드시
          targetScript.dataset.connectHostId = setupUUID
          window[setupUUID] = jumpStarter
        }
      } else {
        console.warn("alpine-tree의 셋업 스크립트가 없습니다.\n <script data-alpine-tree-target=\"setup\">xSetupStart(...)</script> 태그를 사용을 권장합니다.")
        setupAlpineData({})
      }
    }
  }
})
